import { PaymentConfig } from '@order/orderTypes'
import { usePaymentValues } from './usePaymentValues'

const usePaymentStatusAmounts = ({
  payment,
  values,
}: {
  payment: PaymentConfig
  values: ReturnType<ReturnType<typeof usePaymentValues>>
}) => {
  const { discounted, toPay } = values

  const paymentAmount = payment.amount

  return {
    paid: payment.status === 'completed' ? paymentAmount : 0,
    processing: payment.status === 'waiting' ? paymentAmount : 0,
    paymentAmount,
    left: Math.max(toPay - paymentAmount, 0),
    //
    total: discounted,
    toPay,
  }
}

export type PaymentStatusAmounts = ReturnType<typeof usePaymentStatusAmounts>

export default usePaymentStatusAmounts
